module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/do-64a9810e7d07e3af7412bee6afe85102.svg";